// this util will Normalize phone number by removing +966, 966, 00, or leading 0
const normalizeSaudiPhone = (phone = "") => {
  return phone
    .replace(/^(\+)?(966|0{1,2})?/, "") // Remove +966, 966, +0, +00, 00, or leading 0
    .replace(/^0+/, "") // Remove any remaining leading 0s
    .trim();
};

export default normalizeSaudiPhone;
